// Landing-page photography for Future Smart Lab.
// Black and African children and teenagers learning, building and showing
// their work, chosen to match who the academy teaches (ages 6–18, mostly in
// Nigeria). Free-licence Unsplash photos, cropped and stored in
// public/images/landing (sources in public/images/landing-sources.json).
// The (w, h) arguments are kept so call sites read the same; the files are
// already sized for their slots.
const local = (name: string) => `/images/landing/${name}.jpg`;

export const IMG = {
  /** Hero: a smiling girl holding her laptop */
  heroKid: (_w?: number, _h?: number) => local("hero"),
  /** A teenager creating on a laptop */
  builder: (_w?: number, _h?: number) => local("builder"),
  /** Girls at computers with their teacher */
  classroom: (_w?: number, _h?: number) => local("classroom"),
  /** Girls building a robot together, hands on */
  roboticsLab: (_w?: number, _h?: number) => local("building"),
  /** A girl building her project on a laptop */
  showcase: (_w?: number, _h?: number) => local("showcase"),
  /** Two girls working out a problem together at a computer */
  team: (_w?: number, _h?: number) => local("team"),
  /** Young children learning together on a laptop (ages 6–9) */
  creativity: (_w?: number, _h?: number) => local("foundation"),
  /** A boy in an online class (ages 9–12) */
  peers: (_w?: number, _h?: number) => local("explorers"),
  /** Two smiling schoolboys */
  win: (_w?: number, _h?: number) => local("win"),
  /** A young boy at his computer desk */
  create: (_w?: number, _h?: number) => local("create"),
};

/** Social-share (OG) image for SEO. */
export const OG_IMAGE = "https://www.futuresmartlab.com/images/landing/og.jpg";
